export const en = {
  // General
  app_name: "Namaa",
  admin_panel: "Admin Panel",
  dashboard: "Dashboard",
  save: "Save",
  cancel: "Cancel",
  delete: "Delete",
  edit: "Edit",
  add: "Add",
  search: "Search",
  filter: "Filter",
  actions: "Actions",
  loading: "Loading...",
  no_data: "No data available",
  confirm_delete: "Are you sure you want to delete?",
  yes: "Yes",
  no: "No",
  status: "Status",
  active: "Active",
  inactive: "Inactive",
  created_at: "Created At",
  updated_at: "Updated At",
  view: "View",
  back: "Back",
  close: "Close",
  submit: "Submit",
  reset: "Reset",
  export: "Export",
  import: "Import",
  download: "Download",
  upload: "Upload",
  select: "Select",
  all: "All",
  none: "None",
  required: "Required",
  optional: "Optional",
  
  // Auth
  login: "Login",
  logout: "Logout",
  username: "Username",
  password: "Password",
  login_title: "Admin Panel Login",
  login_subtitle: "Enter your credentials",
  invalid_credentials: "Invalid credentials",
  
  // Navigation
  nav: {
    dashboard: "Dashboard",
    master_data: "Master Data",
    regions: "Regions",
    cities: "Cities",
    districts: "Districts",
    categories: "Categories",
    subcategories: "SubCategories",
    map_categories: "Map Categories",
    projects: "Projects",
    outlets: "Sales Outlets",
    success_stories: "Success Stories",
    statistics: "Statistics",
    stat_definitions: "Stat Definitions",
    stat_values: "Stat Values",
    region_statistics: "Region Statistics",
    import_center: "Import Center",
    import_history: "Import History",
    import_errors: "Import Errors",
    review_queue: "Review Queue",
    media: "Media",
    aliases: "Aliases",
    settings: "Settings",
  },
  
  // Dashboard
  total_projects: "Total Projects",
  total_outlets: "Total Outlets",
  total_regions: "Total Regions",
  total_cities: "Total Cities",
  pending_reviews: "Pending Reviews",
  import_errors_count: "Import Errors",
  published_projects: "Published Projects",
  sample_projects: "Sample Projects",
  projects_by_region: "Projects by Region",
  recent_imports: "Recent Imports",
  
  // Regions
  regions: "Regions",
  region: "Region",
  add_region: "Add Region",
  edit_region: "Edit Region",
  region_name_ar: "Region Name (Arabic)",
  region_name_en: "Region Name (English)",
  
  // Cities
  cities: "Cities",
  city: "City",
  add_city: "Add City",
  edit_city: "Edit City",
  city_name_ar: "City Name (Arabic)",
  city_name_en: "City Name (English)",
  select_region: "Select Region",
  
  // Districts
  districts: "Districts",
  district: "District",
  add_district: "Add District",
  edit_district: "Edit District",
  district_name_ar: "District Name (Arabic)",
  district_name_en: "District Name (English)",
  select_city: "Select City",
  
  // Categories
  categories: "Categories",
  category: "Category",
  add_category: "Add Category",
  edit_category: "Edit Category",
  category_name_ar: "Category Name (Arabic)",
  category_name_en: "Category Name (English)",
  category_code: "Category Code",
  category_icon: "Category Icon",
  display_order: "Display Order",
  
  // SubCategories
  subcategories: "SubCategories",
  subcategory: "SubCategory",
  add_subcategory: "Add SubCategory",
  edit_subcategory: "Edit SubCategory",
  subcategory_name_ar: "SubCategory Name (Arabic)",
  subcategory_name_en: "SubCategory Name (English)",
  select_category: "Select Category",
  
  // Projects
  projects: "Projects",
  project: "Project",
  add_project: "Add Project",
  edit_project: "Edit Project",
  project_name_ar: "Project Name (Arabic)",
  project_name_en: "Project Name (English)",
  latitude: "Latitude",
  longitude: "Longitude",
  icon_name: "Icon Name",
  icon_code: "Icon Code",
  project_status: "Project Status",
  review_status: "Review Status",
  data_source: "Data Source",
  notes: "Notes",
  is_sample: "Sample Project",
  draft: "Draft",
  published: "Published",
  archived: "Archived",
  pending: "Pending",
  approved: "Approved",
  rejected: "Rejected",
  select_subcategory: "Select SubCategory",
  select_district: "Select District",
  
  // Outlets
  outlets: "Sales Outlets",
  outlet: "Sales Outlet",
  add_outlet: "Add Sales Outlet",
  edit_outlet: "Edit Sales Outlet",
  outlet_name_ar: "Outlet Name (Arabic)",
  outlet_name_en: "Outlet Name (English)",
  outlet_category: "Outlet Category",
  project_info: "Project Info",
  classification_number: "Classification Number",
  
  // Statistics
  statistics: "Statistics",
  stat_definitions: "Statistic Definitions",
  stat_values: "Statistic Values",
  add_stat_definition: "Add Statistic Definition",
  edit_stat_definition: "Edit Statistic Definition",
  stat_code: "Statistic Code",
  stat_name_ar: "Statistic Name (Arabic)",
  stat_name_en: "Statistic Name (English)",
  stat_description: "Description",
  stat_type: "Statistic Type",
  stat_icon: "Icon",
  applies_to: "Applies To",
  scope_type: "Scope Type",
  scope_id: "Scope ID",
  value_numeric: "Numeric Value",
  value_text: "Text Value",
  period_label: "Period Label",
  source: "Source",
  is_published: "Published",
  number: "Number",
  percentage: "Percentage",
  currency: "Currency",
  text: "Text",
  global: "Global",
  
  // Import
  import_center: "Import Center",
  import_history: "Import History",
  import_errors: "Import Errors",
  upload_file: "Upload File",
  select_import_type: "Select Import Type",
  import_type: "Import Type",
  drop_file_here: "Drop file here or click to select",
  supported_formats: "Supported formats: Excel (.xlsx, .xls), JSON (.json)",
  file_uploaded: "File uploaded",
  process_import: "Process Import",
  import_status: "Import Status",
  total_rows: "Total Rows",
  success_rows: "Success Rows",
  error_rows: "Error Rows",
  completed: "Completed",
  completed_with_errors: "Completed with Errors",
  processing: "Processing",
  failed: "Failed",
  row_number: "Row Number",
  error_type: "Error Type",
  error_message: "Error Message",
  
  // Review Queue
  review_queue: "Review Queue",
  entity_type: "Entity Type",
  issue_type: "Issue Type",
  original_value: "Original Value",
  suggested_value: "Suggested Value",
  resolution_notes: "Resolution Notes",
  approve: "Approve",
  reject: "Reject",
  resolve: "Resolve",
  
  // Media
  media_library: "Media Library",
  upload_media: "Upload Media",
  file_name: "File Name",
  file_size: "File Size",
  file_type: "File Type",
  uploaded_by: "Uploaded By",
  uploaded_at: "Uploaded At",
  
  // Aliases
  aliases: "Aliases",
  add_alias: "Add Alias",
  alias_value: "Alias Value",
  master_record: "Master Record",
  master_name: "Master Name",
  
  // Validation Messages
  validation: {
    required: "This field is required",
    invalid_email: "Invalid email address",
    min_length: "Minimum length is {min} characters",
    max_length: "Maximum length is {max} characters",
    invalid_coordinates: "Invalid coordinates",
    subcategory_mismatch: "SubCategory does not belong to selected Category",
    city_mismatch: "City does not belong to selected Region",
    district_mismatch: "District does not belong to selected City",
  },
  
  // Success Messages
  success: {
    created: "Created successfully",
    updated: "Updated successfully",
    deleted: "Deleted successfully",
    imported: "Imported successfully",
    uploaded: "Uploaded successfully",
  },
  
  // Error Messages
  error: {
    general: "An error occurred, please try again",
    not_found: "Item not found",
    unauthorized: "Unauthorized action",
    delete_has_children: "Cannot delete, item has children",
  },
};
